import { createFileRoute } from '@tanstack/react-router';
import { LogListCard } from '@/features/logs/LogCards';

export const Route = createFileRoute('/r/$restaurantId/logs/')({
  component: LogListPage,
});

function LogListPage() {
  const { restaurantId } = Route.useParams();

  return <LogListCard restaurantId={restaurantId} />;
}
